import axios from '@/plugins/axios'

import { useAuthorizationStore } from '@/store/authorizationStore'

const getWorkspaceId = () => useAuthorizationStore().getWorkspaceSlug

const getAllCallFlows = () => axios.get(`${getWorkspaceId()}/ivr/all`)

const getCallFlowFiltersAndSorting = () => axios.get(`${getWorkspaceId()}/ivr/filters-and-sorting`)
const getCallFlows = (params) => axios.get(`${getWorkspaceId()}/ivr/paginated`, { params })

const getDetailCallFlow = (slug) => axios.get(`${getWorkspaceId()}/ivr/${slug}`)
const createCallFlow = (formData) => axios.post(`${getWorkspaceId()}/ivr`, formData)
const updateCallFlow = ({ formData, slug }) => axios.patch(`${getWorkspaceId()}/ivr/${slug}`, formData)
const deleteCallFlow = (data) => axios.delete(`${getWorkspaceId()}/ivr`, { data })
const cloneCallFlow = ({ formData, slug }) => axios.post(`${getWorkspaceId()}/ivr/${slug}`, formData)

const getFiltersPath = (slug) => axios.get(`${getWorkspaceId()}/ivr/${slug}/paths/filters`)
const getGeoParameters = (slug) => axios.get(`${getWorkspaceId()}/ivr/${slug}/geo/params-tree`)
const sendBlaFilterTestRequest = ({ slug, blockSlug, formData }) => axios.post(`${getWorkspaceId()}/ivr/${slug}/bla-filter/${blockSlug}/test-request`, formData)
const sendTcpaLitigatorTestRequest = ({ slug, blockSlug, formData }) => axios.post(`${getWorkspaceId()}/ivr/${slug}/tcpa-litigator/${blockSlug}/test-request`, formData)
const getHttpRouterParameters = (slug) => axios.get(`${getWorkspaceId()}/ivr/${slug}/http-router/params-tree`)

const getScriptNodeParameters = (slug) => axios.get(`${getWorkspaceId()}/ivr/${slug}/script-node/params-tree`)
const sendTestScriptRequest = (formData) => axios.post(`${getWorkspaceId()}/ivr/script-node/test-script`, formData)

const sendHttpRouterTestRequest = (slug, block, formData) => axios.post(`${getWorkspaceId()}/ivr/${slug}/http-router/${block}/test-request`, formData, { headers: { 'Disabled-Check-Error': true } })

export {
    getAllCallFlows,
    getCallFlowFiltersAndSorting,
    getCallFlows,
    getDetailCallFlow,
    createCallFlow,
    updateCallFlow,
    deleteCallFlow,
    cloneCallFlow,

    getHttpRouterParameters,

    getScriptNodeParameters,
    sendTestScriptRequest,

    sendHttpRouterTestRequest,

    getFiltersPath,
    getGeoParameters,
    sendBlaFilterTestRequest,
    sendTcpaLitigatorTestRequest,
}
